import React from 'react';
import { styled } from "@mui/material";

type CodeBlockProps = {
    children: string;
}
const CodeBlock = ({ children }: CodeBlockProps) => (
    <StyledPre>{children.trim()}</StyledPre>
);

const StyledPre = styled('pre')({
    background: '#f5f5f5',
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    padding: '12px 16px',
    margin: '8px 0 16px',
    overflowX: 'auto',
    fontFamily: "'Courier New', Courier, monospace",
    fontSize: 13,
    whiteSpace: 'pre',
});

export default CodeBlock;
